import React from 'react'
import ApplicationsComponent from '../../components/Applications/applicationsComponent'
import './Applications.css'


const Applications = () => {
  return (
    <>
      <div className="container">
         <ApplicationsComponent/>
      </div>
    </>
  )
}

export default Applications
